import { FB_Template } from "@algomusinc/domain";
import { getNumberValue } from "./getNumberValue";

export const calcForecastMeasuresGDP = (
  key: string,
  gridListUI: Array<any>,
  parentKey: string,
  mivIndex?: number,
  fbTemplateId?: number | any,
  fbForecastMIVResponseModelKey?: string
  ): any => {
  if([FB_Template.Multi_ItemView, FB_Template.Customer_Order_Planner, FB_Template.REPL_PLANNER, FB_Template.PP_Planner].includes(fbTemplateId)){
    return calcForecastMeasuresGDPMulti(
      key,
      gridListUI,
      parentKey,
      mivIndex,
      fbTemplateId,
      fbForecastMIVResponseModelKey,
    )
  }else{
    let GDPTotalForecast;
    let timeframeColumn = gridListUI.find((row) => row.title === key);
    if(timeframeColumn && timeframeColumn[parentKey]){
      const GDPManualFcstAdjustmentPct = timeframeColumn[parentKey]['GDPManualFcstAdjustmentPct'] || 0;
      const GDPPromoFcstAdjustmentPct = timeframeColumn[parentKey]['GDPPromoFcstAdjustmentPct'] || 0;
      if (
        GDPManualFcstAdjustmentPct !== 'Multiple %' &&
        GDPPromoFcstAdjustmentPct !== 'Multiple %'
      ) {
        const GDPBaselineFcst = timeframeColumn[parentKey]['GDPBaselineFcst'];
        let GDPManualFcstAdjustment =timeframeColumn[parentKey]['GDPManualFcstAdjustment'];
        let GDPBaselineAttachRateQuantity = timeframeColumn[parentKey]['GDPBaselineAttachRateQuantity'];
        let GDPPromoUnits = timeframeColumn[parentKey]['GDPPromoUnits'];
        if (GDPBaselineFcst == 0) {
          GDPPromoUnits = 0;
          GDPManualFcstAdjustment = 0;
        }
        const pctManualValue = GDPManualFcstAdjustmentPct / 100;
        const pctPromoValue = GDPPromoFcstAdjustmentPct / 100;
        GDPTotalForecast = Math.round(
          (getNumberValue(GDPBaselineFcst) +
            getNumberValue(GDPManualFcstAdjustment) +
            getNumberValue(GDPBaselineAttachRateQuantity) +
            getNumberValue(GDPPromoUnits) * (1 + pctPromoValue)) *
            (1 + pctManualValue)
        );
      }
    }
    return GDPTotalForecast;
  }
};
function calcForecastMeasuresGDPMulti(
  key: string,
  gridListUI: Array<any>,
  parentKey: string,
  mivIndex: any,
  fbTemplateId: any,
  fbForecastMIVResponseModelKey: any
) {
  let GDPTotalForecast;
  let timeframeColumn = gridListUI.find((row) => row.title === key);
  if(timeframeColumn && timeframeColumn[fbForecastMIVResponseModelKey] && timeframeColumn[fbForecastMIVResponseModelKey][mivIndex][parentKey]){
    const GDPManualFcstAdjustmentPct = timeframeColumn[fbForecastMIVResponseModelKey][mivIndex][parentKey]['GDPManualFcstAdjustmentPct'] || 0;
    const GDPPromoFcstAdjustmentPct = timeframeColumn[fbForecastMIVResponseModelKey][mivIndex][parentKey]['GDPPromoFcstAdjustmentPct'] || 0;
    if (
      GDPManualFcstAdjustmentPct !== 'Multiple %' &&
      GDPPromoFcstAdjustmentPct !== 'Multiple %'
      ) {
      const GDPBaselineFcst = timeframeColumn[fbForecastMIVResponseModelKey][mivIndex][parentKey]['GDPBaselineFcst'];
      let GDPManualFcstAdjustment = timeframeColumn[fbForecastMIVResponseModelKey][mivIndex][parentKey]['GDPManualFcstAdjustment'];
      let GDPBaselineAttachRateQuantity = timeframeColumn[fbForecastMIVResponseModelKey][mivIndex][parentKey]['GDPBaselineAttachRateQuantity'];
      let GDPPromoUnits = timeframeColumn[fbForecastMIVResponseModelKey][mivIndex][parentKey]['GDPPromoUnits'];
      if (GDPBaselineFcst == 0) {
        GDPManualFcstAdjustment = 0;
        GDPPromoUnits = 0;
      }
      const pctManualValue = GDPManualFcstAdjustmentPct / 100;
      const pctPromoValue = GDPPromoFcstAdjustmentPct / 100;
      GDPTotalForecast = Math.round(
        (getNumberValue(GDPBaselineFcst) +
          getNumberValue(GDPManualFcstAdjustment) +
          getNumberValue(GDPBaselineAttachRateQuantity) +
          getNumberValue(GDPPromoUnits) * (1 + pctPromoValue)) *
          (1 + pctManualValue)
      );
    }
  }
  return GDPTotalForecast;
}

